module.exports = __webpack_public_path__ + "static/media/Sohne-Kraftig.e7739a18.otf";